import { IMissingInfoFilters } from '../../../types'

export const removeMissingInfoFilter = (
  selectedFilters: IMissingInfoFilters[],
  filterToRemove: IMissingInfoFilters
): IMissingInfoFilters[] => {
  if (filterToRemove === IMissingInfoFilters.any) {
    return selectedFilters
  }

  if (selectedFilters.length === 1) {
    return [IMissingInfoFilters.any]
  }

  return selectedFilters.filter(selectedFilter => selectedFilter !== filterToRemove)
}
